import type { StateTone } from '@sentinel/ui';
import type { BandwidthLevel, LinkState } from '@sentinel/shared';

/** The state tone of a bandwidth level (DS rule 1: with its glyph and its word). */
export const LEVEL_TONE: Record<BandwidthLevel, StateTone> = {
  full: 'ok',
  reduced: 'att',
  minimal: 'att',
  offline: 'crit',
};

export const LINK_TONE: Record<LinkState, StateTone> = {
  up: 'ok',
  degraded: 'att',
  down: 'crit',
};
